export default __webpack_public_path__ + "static/media/FirstJoin.5933f164.svg";